export const ORDERS_VIEW_LIST = 'DELIVERY_ORDERS_VIEW_LIST';
export const ORDERS_VIEW_ANY_LIST = 'DELIVERY_ORDERS_VIEW_ANY_LIST';
export const ORDERS_VIEW = 'DELIVERY_DELIVERY_ORDERS_VIEW';
export const ORDERS_EDIT = 'DELIVERY_ORDERS_EDIT';
export const ORDERS_CREATE = 'DELIVERY_ORDERS_CREATE';
export const ORDERS_STATUS_EDIT = 'DELIVERY_ORDERS_STATUS_EDIT';
